/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_ManagementInputs */

const en_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Management`)
};

const fr_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des abonnements`)
};

const de_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementverwaltung`)
};

const it_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione degli abbonamenti`)
};

const ru_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление подписками`)
};

const es_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de suscripciones`)
};

const zh_cn2_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅管理`)
};

const ja_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション管理`)
};

const hi_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता प्रबंधन`)
};

const pt_pt2_subscription_management = /** @type {(inputs: Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de Assinaturas`)
};

/**
* | output |
* | --- |
* | "Subscription Management" |
*
* @param {Subscription_ManagementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_management = /** @type {((inputs?: Subscription_ManagementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_ManagementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_management(inputs)
	if (locale === "de") return de_subscription_management(inputs)
	if (locale === "it") return it_subscription_management(inputs)
	if (locale === "ru") return ru_subscription_management(inputs)
	if (locale === "es") return es_subscription_management(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_management(inputs)
	if (locale === "ja") return ja_subscription_management(inputs)
	if (locale === "hi") return hi_subscription_management(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_management(inputs)
	return en_subscription_management(inputs)
});